import React from 'react'
import styled from 'styled-components'
import { ConfigConsumer } from 'contexts/config-context'
import { ProfileConsumer } from 'contexts/profile-context'
import { BrowserConsumer } from 'contexts/browser-context'
import Avatar from 'atoms/Avatar'
import Link from 'atoms/Link'
import WalletBalance from 'atoms/WalletBalance'
import GiftIcon from 'images/icons/Gift'
import { totalBonusAmount, bonusTotalsByClient } from 'tools/wallet'
import Accordion from 'molecules/Accordion'
import { themeByWalletClientId } from 'tools/theme'
import PromoNotifications from 'molecules/PromoNotifications'
import NoviceIcon from 'images/icons/fanball/novice.png'
import { SettingsConsumer } from 'contexts/settings-context'

const ProfileSection = styled.div`
  padding: 12px;
`

const UsernameSection = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 16px;
`

const ProfileStats = styled.div`
  display: flex;
`

const StatItem = styled.div`
  flex: 1;
`

const Label = styled.div`
  font-size: 12px;
  line-height: 12px;
  padding: 0 0 4px;
`

const Value = styled.div`
  font-weight: bold;
  font-size: 18px;
  line-height: 18px;

  a {
    color: inherit;
  }
`

const BonusDetails = styled.div`
  background: rgba(85, 188, 189, 1);
  padding: 8px 0 8px 8px;
  color: #fff;
  display: flex;
  align-items: center;

  svg {
    height: 20px;
    width: 20px;
    margin: 0 8px 0 0;
  }
`

const BonusBody = styled.div`
  background: #fff;
`

const LightLabel = styled.span`
  font-weight: 300;
  font-size: 12px;
  padding: 0 8px 0 0;
`

const BrandBonusWrapper = styled.div`
  padding: 8px 16px;
  display: flex;
  align-items: center;

  &:not(:last-child) {
    border-bottom: 1px solid #e0e0e0;
  }

  svg {
    width: 24px;
    height: 24px;
    margin: 0 8px 0 0;
  }

  strong {
    font-size: 14px;
  }
`

const GiftBoxButton = styled.span`
  background: #b2babd;
  padding: 8px;
  margin: -6px -12px 0 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
`

const UserNameWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const IconWrapper = styled.div`
  padding: 8px 0 0 8px;
`

function LoggedInTopper(props) {
  return (
    <BrowserConsumer>
      {(browser) => (
        <React.Fragment>
          <ProfileSection>
            <UsernameSection>
              <ProfileConsumer>
                {(profile) => {
                  if (!profile) {
                    return null
                  }
                  return (
                    <React.Fragment>
                      <UserNameWrapper>
                        {browser.lessThan.large && <Avatar picture={profile.picture} />}
                        <div>@{profile.preferred_username}</div>
                        <ConfigConsumer>
                          {(config) =>
                            config.isBeginner && (
                              <Link
                                href={`https://www.fanball.com/how-to-play${browser.lessThan.large ? '#novice' : ''}`}
                              >
                                <SettingsConsumer>
                                  {(settings) => {
                                    return (
                                      <IconWrapper>
                                        <img src={`${settings.HOSTNAME}${NoviceIcon}`} height="20px" />
                                      </IconWrapper>
                                    )
                                  }}
                                </SettingsConsumer>
                              </Link>
                            )
                          }
                        </ConfigConsumer>
                      </UserNameWrapper>
                    </React.Fragment>
                  )
                }}
              </ProfileConsumer>
            </UsernameSection>
            <ProfileStats>
              <ConfigConsumer>
                {(config) =>
                  config.tickets && (
                    <StatItem>
                      <Label>{config.tickets.label || 'Tickets'}</Label>
                      <Value>
                        <Link href={config.tickets.url}>
                          <span>{config.tickets.count}</span>
                        </Link>
                      </Value>
                    </StatItem>
                  )
                }
              </ConfigConsumer>
              <StatItem>
                <Label>Balance</Label>
                <Value>
                  <WalletBalance />
                </Value>
              </StatItem>
              <ProfileConsumer>
                {(profile) => {
                  const totalBonuses = totalBonusAmount(profile.bonuses)
                  if (totalBonuses > 0) {
                    return (
                      <GiftBoxButton>{browser.greaterThan.large ? <GiftIcon /> : <PromoNotifications />}</GiftBoxButton>
                    )
                  } else {
                    return null
                  }
                }}
              </ProfileConsumer>
            </ProfileStats>
          </ProfileSection>
          <ProfileConsumer>
            {(profile) => {
              const totalBonuses = totalBonusAmount(profile.bonuses)
              if (totalBonuses > 0) {
                const totalsByClient = bonusTotalsByClient(profile.bonuses)
                return (
                  <Accordion
                    caretTheme="white"
                    trigger={
                      <BonusDetails>
                        <GiftIcon />
                        <React.Fragment>
                          <LightLabel>Bonus Money: </LightLabel>
                          <strong>
                            {totalBonuses.toLocaleString('en-US', {
                              style: 'currency',
                              currency: 'USD',
                              minimumFractionDigits: 2,
                            })}
                          </strong>
                        </React.Fragment>
                      </BonusDetails>
                    }
                  >
                    <BonusBody>
                      {totalsByClient.map((client, index) => {
                        const theme = themeByWalletClientId(client.name)
                        if (theme === undefined) {
                          return null
                        }
                        return (
                          <BrandBonusWrapper key={`TotalsByClient-${client.name}`}>
                            {theme.shield} <LightLabel>{theme.displayName}:</LightLabel>{' '}
                            <strong>
                              {client.balance.toLocaleString('en-US', {
                                style: 'currency',
                                currency: 'USD',
                                minimumFractionDigits: 2,
                              })}
                            </strong>
                          </BrandBonusWrapper>
                        )
                      })}
                    </BonusBody>
                  </Accordion>
                )
              } else {
                return null
              }
            }}
          </ProfileConsumer>
        </React.Fragment>
      )}
    </BrowserConsumer>
  )
}

export default LoggedInTopper



// WEBPACK FOOTER //
// ./src/molecules/UserProfile/components/LoggedInTopper.js